import { i as b, B as g, x as c, n as u, T as v, a as m } from "../separate-component-helper-chunks/abstract-base-0be59b32.js";
import { o as n } from "../separate-component-helper-chunks/if-defined-8ef2f2d4.js";
import { l as h } from "../separate-component-helper-chunks/live-9d9d6cfd.js";
import { B as C } from "../separate-component-helper-chunks/form-base-29359abe.js";
import { I as w } from "../separate-component-helper-chunks/icon-position-716424dc.js";
import { a as y } from "../separate-component-helper-chunks/query-assigned-1d8bbbb5.js";
import "../separate-component-helper-chunks/directive-daf4e9b6.js";
import "../separate-component-helper-chunks/directive-helpers-108b30b5.js";
import "../separate-component-helper-chunks/form-associated-aaa09067.js";
import "../separate-component-helper-chunks/lifecycle-decorators-ecc4e836.js";
import "../separate-component-helper-chunks/utils-2e24a437.js";
import "../separate-component-helper-chunks/query-24926cff.js";
const r = {
  defaultTime: "T00:00:00",
  year: "numeric",
  month: "2-digit",
  day: "2-digit"
}, x = b`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}input{--border-color: var(--beacon-form-field-color-border-default);--border-size: var(--beacon-form-field-size-border-width-default);--font-color: var(--beacon-form-field-color-text-default);background-color:var(--beacon-form-field-color-background);block-size:var(--beacon-form-field-size-block);border:var(--border-size) solid var(--border-color);border-radius:var(--beacon-form-field-size-border-radius);color:var(--font-color);font-size:var(--beacon-form-font-size);inline-size:100%;line-height:var(--beacon-form-font-line-height);margin-block-start:var(--beacon-custom-form-field-space-margin-block-start, var(--beacon-form-field-space-margin));margin-inline-start:0;padding-inline:var(--beacon-form-field-space-padding)}input.error{--border-size: var(--beacon-form-field-size-border-width-error);--border-color: var(--beacon-form-field-color-border-error)}input:not([type=date]).error{--font-color: var(--beacon-form-field-color-text-error)}input:not([type=date]).error:focus{--font-color: var(--beacon-form-field-color-text-default)}:host([icon-position]) input{background-image:var(--input-field-icon, none);background-position:var(--input-icon-position, none);background-repeat:no-repeat}:host([icon-position=left]){--input-icon-position: var(--beacon-form-icon-space-position-inline-start)}:host([icon-position=left]) input:not([type=date]){padding-inline-start:var(--beacon-form-icon-space-padding)}:host([icon-position=right]){--input-icon-position: var(--beacon-form-icon-space-position-inline-end)}:host([icon-position=right]) input:not([type=date]){padding-inline-end:var(--beacon-form-icon-space-padding)}::-webkit-calendar-picker-indicator{background-image:var(--calendar-icon, url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect width='16' height='16' fill='%23F4F5F6'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.25 1V2.00004H2.33325C1.78097 2.00004 1.33325 2.44776 1.33325 3.00004V4.33337V14.3334C1.33325 14.8857 1.78097 15.3334 2.33325 15.3334H13.6666C14.2189 15.3334 14.6666 14.8857 14.6666 14.3334V4.33337V3.00004C14.6666 2.44776 14.2189 2.00004 13.6666 2.00004H12.75V1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.00004H4.75V1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1ZM13.6666 5.33337H2.33325V14.3334L13.6666 14.3334V5.33337Z' fill='%23086EA1'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' stroke='%23BEC3C8' stroke-width='2'/%3E%3C/svg%3E"))}:host([disabled]){--calendar-icon: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Crect width='16' height='16' fill='%23F4F5F6'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' fill='white'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M3.25 1V2.00004H2.33325C1.78097 2.00004 1.33325 2.44776 1.33325 3.00004V4.33337V14.3334C1.33325 14.8857 1.78097 15.3334 2.33325 15.3334H13.6666C14.2189 15.3334 14.6666 14.8857 14.6666 14.3334V4.33337V3.00004C14.6666 2.44776 14.2189 2.00004 13.6666 2.00004H12.75V1C12.75 0.585786 12.4142 0.25 12 0.25C11.5858 0.25 11.25 0.585786 11.25 1V2.00004H4.75V1C4.75 0.585786 4.41421 0.25 4 0.25C3.58579 0.25 3.25 0.585786 3.25 1ZM13.6666 5.33337H2.33325V14.3334L13.6666 14.3334V5.33337Z' fill='%237C8790'/%3E%3Crect x='-924' y='-973' width='2002' height='2629' stroke='%23BEC3C8' stroke-width='2'/%3E%3C/svg%3E")}:host([icon-position]) input{display:flex}:host([icon-position=left]) input[type=date]{flex-direction:row-reverse;gap:calc(.75 * var(--beacon-unit-base))}
`;
var $ = Object.defineProperty, V = Object.getOwnPropertyDescriptor, p = (s, e, t, o) => {
  for (var i = o > 1 ? void 0 : o ? V(e, t) : e, l = s.length - 1, d; l >= 0; l--)
    (d = s[l]) && (i = (o ? d(e, t, i) : d(i)) || i);
  return o && i && $(e, t, i), i;
};
const f = "beacon-date-picker", k = ["beacon-error"];
class a extends g(C) {
  constructor() {
    super(...arguments), this.beaconTagName = f, this.name = "date-picker", this.iconPosition = w.RIGHT;
  }
  static get styles() {
    return [super.styles, x];
  }
  minValidation() {
    var e;
    if (this.value && this.min && typeof this.min == "string" && this.value < this.min) {
      const { defaultTime: t } = r, o = (/* @__PURE__ */ new Date(`${this.min}${t}`)).toLocaleDateString(void 0, {
        year: r.year,
        month: r.month,
        day: r.day
      }), i = this.errorsMap.min || ((e = this.defaultMessages.minDate) == null ? void 0 : e.replace("%X%", o));
      this.setValidity({ rangeUnderflow: !0 }, i);
    }
  }
  maxValidation() {
    var e;
    if (this.value && this.max && typeof this.max == "string" && this.value > this.max) {
      const { defaultTime: t } = r, o = (/* @__PURE__ */ new Date(`${this.max}${t}`)).toLocaleDateString(void 0, {
        year: r.year,
        month: r.month,
        day: r.day
      }), i = this.errorsMap.max || ((e = this.defaultMessages.maxDate) == null ? void 0 : e.replace("%X%", o));
      this.setValidity({ rangeOverflow: !0 }, i);
    }
  }
  render() {
    var e, t;
    return this.requiredProps = ["label", "id"], this.validateRequiredProps(), this.invalid = !((e = this.internals) != null && e.checkValidity()), c` <label for=${this.id}>${this.label}</label>
      ${this.hint ? c`<p class="hint" id="hint">${this.hint}</p>` : c``}
      ${this.invalid ? u`<${this.getScopedTag("beacon-error")} message="${(t = this.internals) == null ? void 0 : t.validationMessage}" id="error"></${this.getScopedTag(
      "beacon-error"
    )}>` : v}
      <input
        type="date"
        title=${n(this.title)}
        id=${this.id}
        aria-describedby="${n(
      this.hint || this.invalid ? [this.hint ? "hint" : "", this.invalid ? "error" : ""].join(" ").trim() : void 0
    )}"
        aria-invalid=${h(this.invalidStateAsString)}
        aria-disabled=${h(this.disabledStateAsString)}
        class="${this.invalid ? "error" : ""} form-anchor"
        name=${this.name}
        min=${n(this.min)}
        max=${n(this.max)}
        .value=${h(this.value)}
        ?required=${this.required}
        ?invalid=${this.invalid}
        @input=${this.handleInput}
        @blur=${this.handleBlur}
        @keydown=${this.handleKeydown}
        @mousedown=${this.handleMousedown}
        @change=${this.emitChange}
      />`;
  }
  connectedCallback() {
    var e;
    (e = this.handleDefer()) == null || e.then(() => {
      super.connectedCallback();
    });
  }
}
a.tagName = f;
a.nestedComponents = k;
p([
  m({ reflect: !0 })
], a.prototype, "name", 2);
p([
  m({ attribute: "icon-position" })
], a.prototype, "iconPosition", 2);
p([
  y("input#date-picker")
], a.prototype, "input", 2);
export {
  a as BeaconDatePicker
};
